// extracted by mini-css-extract-plugin
export default {"searchInput":"styles_searchInput__REm+2","input":"styles_input__3irc+","searchIcon":"styles_searchIcon__0HNC6"};